export const formatMonth = (dateString, months) => {

    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
}

export const getDuration = (fromDateStr, toDateStr) => {
    const fromDate = new Date(fromDateStr);
    const toDate = new Date(toDateStr);

    let years = toDate.getFullYear() - fromDate.getFullYear();
    let months = toDate.getMonth() - fromDate.getMonth();

    if (months < 0) {
        years--;
        months += 12;
    }

    const yearPart = years > 0 ? `${years} year${years > 1 ? 's' : ''}` : '';
    const monthPart = months > 0 ? `${months} month${months > 1 ? 's' : ''}` : '';

    if (yearPart && monthPart) {
        return `${yearPart}, ${monthPart}`;
    } else {
        return yearPart || monthPart || '0 months';
    }
}


export const renderExpDuration = (from, to, current) => {
    if (!from || (!to && !current)) return null

    if (current) {
        return <span className=' bg-green-100 text-green-800 text-sm px-2 rounded-full '>Current</span>
    }
    else if (from && to) {
        return <span className='text-base text-gray-500 font-normal'>{getDuration(from, to)}</span>
    }

    return null
}